import React from 'react';
import { UnderlinedText } from '@zola/zola-ui/src/components/UnderlinedText';

import css from '~/pages/wedding-registry/how-cash-gifts-work/cash.module.less';

const GetMoreTextSection: React.FC = () => (
  <section className={css.textSection}>
    <h2 className={css.sectionTitle}>Get More Out of Your Funds</h2>
    <div className={css.body}>
      Over{' '}
      <UnderlinedText color="teal">
        <strong>75%</strong>
      </UnderlinedText>{' '}
      of Zola couples register for and receive cash. Here are a few tips we’ve picked up.
    </div>
  </section>
);

export default GetMoreTextSection;
